import { ChevronDown, LogOut, Settings, ShieldCheck, UserRound } from 'lucide-react';
import { NavLink } from 'react-router-dom';

import { Button } from '@/componentes/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/componentes/ui/dropdown-menu';
import { useEu, useSair } from '@/dados';

/* MenuDaConta — sessão e saída, no canto da marca.
 *
 * Mora ao lado do logo, não numa barra fixa: conta é assunto de uma vez por
 * sessão, e uma barra permanente cobrava altura de toda tela para isso. */
export function MenuDaConta() {
  const eu = useEu();
  const sair = useSair();
  const usuario = eu.data;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="sm" className="gap-2">
          <UserRound className="size-4" />
          <span className="hidden max-w-40 truncate mesa:inline">
            {usuario?.email ?? 'Visitante'}
          </span>
          <ChevronDown className="size-3.5 opacity-60" />
        </Button>
      </DropdownMenuTrigger>

      <DropdownMenuContent align="end" className="w-56">
        <DropdownMenuLabel className="font-normal">
          <p className="text-apoio font-medium">{usuario?.email ?? 'Sessão de visitante'}</p>
          <p className="text-tinta-2 text-nota">
            {usuario?.anonimo === false
              ? 'Conta com e-mail'
              : 'Os dados ficam guardados; crie uma conta para acessar de outro aparelho.'}
          </p>
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuItem asChild>
          <NavLink to="/empresa">
            <Settings className="size-4" />
            Dados da empresa
          </NavLink>
        </DropdownMenuItem>
        {/* O painel só aparece para quem tem o papel. Esconder aqui é
            cortesia: quem não é admin recebe 404 em toda rota do painel, e é
            a API que garante isso. */}
        {usuario?.papel === 'admin' ? (
          <DropdownMenuItem asChild>
            <NavLink to="/admin">
              <ShieldCheck className="size-4" />
              Administração
            </NavLink>
          </DropdownMenuItem>
        ) : null}
        {usuario?.anonimo === false ? (
          <DropdownMenuItem onSelect={() => sair.mutate()} disabled={sair.isPending}>
            <LogOut className="size-4" />
            Sair
          </DropdownMenuItem>
        ) : (
          <DropdownMenuItem asChild>
            <NavLink to="/entrar">
              <UserRound className="size-4" />
              Criar conta ou entrar
            </NavLink>
          </DropdownMenuItem>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
